import {Flex, Input, Modal, Space, Typography} from "antd";
import React, {useEffect} from "react";
import '@mdxeditor/editor/style.css';
import {
    MDXEditor
} from '@mdxeditor/editor';
import {TagFlow} from "../../components/TagFlow";
import {Tag} from "../../feature/project/fields";
import {useAppDispatch, useAppSelector} from "../../feature/tools";
import {useParams} from "react-router-dom";
import {Status} from "../../feature/project/status";
import {fetchTags} from "../../feature/project/projectsSlice";
import {Act, Scene} from "../../feature/project/story";
import {addSceneTag, removeSceneTag} from "../../feature/project/sceneSlice";

export interface ActProps {
    scene: Scene,
    visible: boolean,
    onCancel: () => void,
    onSave: (act: Act) => void,
}

export const AddSceneModal = (props: ActProps) => {
    const dispatch = useAppDispatch();
    const {projectId} = useParams();
    const allTags = useAppSelector(state => state.projects.tags)
    const status = useAppSelector(state => state.components.status)
    const [hasChanges, setHasChanges] = React.useState(false)
    const [title, setTitle] = React.useState(props.scene.title)
    const [description, setDescription] = React.useState(props.scene.description)
    const [tags, setTags] = React.useState<Array<Tag>>(props.scene.tags || [])

    useEffect(() => {
        setTitle(props.scene.title)
        setDescription(props.scene.description || '')
        setTags(props.scene.tags || [])
    }, [props.visible, props.scene, props.scene.tags])

    useEffect(() => {
        setHasChanges(title !== props.scene.title || description !== props.scene.description)
    }, [title, description])

    useEffect(() => {
        if (status == Status.Idle && projectId && props.visible) {
            if (props.scene.id) {
                dispatch(fetchTags({projectId: parseInt(projectId)}))
            }
        }
    }, [status, dispatch])

    return (
        <Modal
            maskClosable={false}
            open={props.visible}
            destroyOnClose={true}
            title={props.scene.id ? 'Scene Settings' : `Add Scene`}
            okText={'Save'}
            okButtonProps={{disabled: !hasChanges}}
            onCancel={() => props.onCancel()}
            onOk={() => props.onSave({
                id: props.scene.id,
                title: title || "",
                description: description || "",
                tags: tags
            })
            }
            width={600}
        >
            <Flex gap={16}>
                <Space direction={'vertical'} style={{width: '100%', maxHeight: 400, overflowY: 'auto', scrollbarWidth: "none"}} size={16}>
                    <div>
                        <Typography style={{fontWeight: 700}}>Title</Typography>
                        <Input value={title} onChange={(e) => setTitle(e.target.value)}/>
                    </div>
                    <div>
                        <Typography style={{fontWeight: 700}}>Content</Typography>
                        <MDXEditor
                            className={"markdown-text"}
                            markdown={description || ""}
                            onChange={(e) => setDescription(e)}
                            plugins={[]}
                        />
                    </div>
                    <div>
                        <Typography style={{fontWeight: 700}}>Tags</Typography>
                        <TagFlow allTags={allTags}
                                 tags={tags}
                                 onTagAdded={(tag) => {
                                     setTags([...tags, tag])
                                     if (props.scene.id && projectId) {
                                         dispatch(addSceneTag({
                                             projectId: parseInt(projectId),
                                             sceneId: props.scene.id,
                                             tag: {title: tag.title}
                                         }))
                                     }
                                 }}
                                 onTagDeleted={(tag) => {
                                     if (tag.id && props.scene.id && projectId) {
                                         dispatch(removeSceneTag({
                                             projectId: parseInt(projectId),
                                             sceneId: props.scene.id,
                                             tagId: tag.id
                                         }))
                                     }
                                 }}
                        />
                    </div>
                </Space>
            </Flex>
        </Modal>
    );
}